import { FacialExpressionChildOptionValueEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreFacialExpression } from '@types';

const initialState: IStoreFacialExpression = {
  [FacialExpressionChildOptionValueEnum.혐오]: false,
  [FacialExpressionChildOptionValueEnum.분노]: false,
  [FacialExpressionChildOptionValueEnum.당황]: false
};

export const facialExpressionSlice = createSlice({
  name: 'facialExpression',
  initialState,
  reducers: {
    initFacialExpression: () => {
      return initialState;
    },

    setFacialExpression: (state, action: PayloadAction<IStoreFacialExpression>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initFacialExpression, setFacialExpression } = facialExpressionSlice.actions;

export default facialExpressionSlice.reducer;
